import { getSessionVertical } from '../utils/authStorage';
import { resolveReturnTo } from './returnTo';

/**
 * Module-home back arrow policy:
 * - Management users: show back (they browse across verticals).
 * - Vertical-native users on their own home: hide back (this page is their home).
 * - Anyone with an explicit returnTo: show back (came from a drill-down).
 *
 * @param {string} homeVertical - e.g. 'sales' | 'operations' | 'inventory' | 'marketing' | 'accounts'
 * @param {object} [location] - react-router location (optional)
 */
export function shouldShowModuleHomeBack(homeVertical, location) {
  if (location && resolveReturnTo(location)) return true;

  const session = getSessionVertical();
  if (!session) return false;
  if (session === 'management') return true;

  const home = String(homeVertical || '')
    .trim()
    .toLowerCase();
  if (!home) return session === 'management';

  return session !== home;
}
